import { render } from "./MovieCard.vue?vue&type=template&id=f3e5e0d6&scoped=true"
import script from "./MovieCard.vue?vue&type=script&lang=js"
export * from "./MovieCard.vue?vue&type=script&lang=js"

import "./MovieCard.vue?vue&type=style&index=0&id=f3e5e0d6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3e5e0d6"]])

export default __exports__